import type {AuthStatus, LoginAttempt, PreAuthDetails} from '@/utils/enums/Session';

export enum AuthenticationState {
  Unidentified = 'unidentified',
  Identified = 'identified',
  Abandoned = 'abandoned',
  Pending = 'pending',
}

export enum SessionState {
  Active = 'Active',
  Inactive = 'Inactive',
}

export interface IPreAuthentication {
  attempt: LoginAttempt;
  details: PreAuthDetails;
  time: Date;
}

export interface ISession {
  guid: string;
  glid: string;
  userId: string;
  userName?: string;
  sessionState: SessionState;
  authenticationState: AuthenticationState;
  sessionStart: string;
  sessionEnd?: string;
  preAuthentications: IPreAuthentication[];
  systemType: string;
  IPAddress: string;
  location: string;
  device: string;
  nextExpiryTime: number;
}

export type AuthorizedSession = {
  guid: string;
  glid: string;
  userId: string;
  sessionState: SessionState.Active;
  authenticationState: AuthenticationState.Identified;
  nextExpiryTime: number;
  accessToken: string;
  refreshToken: string;
  sessionStart: Date;
  sessionEnd?: Date;
  isPasswordExpired: boolean;
  userName: string;
  aboutToExpiry: {
    remainingTime: number;
    showPopUp: boolean;
    timeoutOverlay: number;
  };
};

export type SessionPagination = {
  page: number;
  pageSize: number;
};

export type SessionTableRow = ISession & {
  _id: string;
  userDetails: {
    _id: string;
    name: string;
    guid: string;
  } | null;
  authDetails: AuthDetails | null;
};

export type AuthDetails = {
  session_id: string;
  guid: string;
  status: AuthStatus;
};
